module.exports = "/static/assets/b279390376a92ec00c0fc8b7dc09886c.gif";